import axios from "axios";
import { ContextModel } from "models";
import { CommonFileModel } from "models/CommonFileModel";

export * as Category from "./category";
export * as Date from "./date";
export * as Dummy from "./dummy";
export * as Model from "./model";
export * as Store from "./store";

export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });
}

export function addComma(value: number | string, withDigit = true) {
  let options = {} as Intl.NumberFormatOptions;

  if(value === 0) {
    return 0;
  }
  if(!value) {
    return '';
  }

  const n = Number(value);
  if (isNaN(n)) {
    return value;
  }
  
  if(withDigit) {
    options.minimumFractionDigits = 2
  }

  return n.toLocaleString('ja-JP', options);
}

export function addTotalComma(value: number | string) {
  let options = {} as Intl.NumberFormatOptions;

  if(value === 0) {
    return 0;
  }
  if(!value) {
    return '';
  }

  const n = Number(value);
  if (isNaN(n)) {
    return value;
  }
  return n.toLocaleString('ja-JP', options);
}

export  function formatNumericInput(inputValue: any, thousandsSep = ","){
  const sanitizedValue = inputValue;
  const [integerPart, decimalPart = ""] = sanitizedValue.split(".");
  let formattedNumber = integerPart

  if (decimalPart.length > 0) {
    formattedNumber += `.${decimalPart.slice(0, 2)}`;
  }

  const hasDecimal = sanitizedValue.includes(".");
  const formattedIntegerPart = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ","
  );
  return hasDecimal
    ? `${formattedIntegerPart}.${decimalPart.slice(0, 2)}`
    : formattedIntegerPart;
};

export function formatNumericBlur(inputValue: any, thousandsSep = ",") {
  const sanitizedValue = inputValue
    .replace(/[^0-9.-]/g, "")
    .replace(/^(-)|-+/g, "$1")
    .replace(/^([^.]*\.)|\.+/g, "$1");

  const [integerPart, decimalPart = ""] = sanitizedValue.split(".");
  let formattedNumber = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    thousandsSep
  );
  if (decimalPart.length > 0) {
    formattedNumber += `.${decimalPart.slice(0, 2)}`;
  } else if (decimalPart.length === 1) {
    formattedNumber += `.${decimalPart}0`;
  }
  const hasDecimal = sanitizedValue.includes(".");
  console.log("hasDecimal", hasDecimal);
  const formattedIntegerPart = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ","
  );
  const result = hasDecimal
    ? `${formattedIntegerPart}.${decimalPart.slice(0, 2)}`
    : formattedIntegerPart;
  if (/^\.[0-9]+$/.test(result)) {
    return `0${result}`;
  }
  return result;
};

export function randomStr(digit: number) {
  let r = Math.random().toString(32);
  return r.substring(2, 2 + digit);
}

export function arrayBufferToBinaryString(arrayBuffer: ArrayBuffer) {
  let binaryString = "";
  const bytes = new Uint8Array(arrayBuffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binaryString += String.fromCharCode(bytes[i]);
  }
  return binaryString;
}

export function errorAction(ctx: ContextModel, err: any) {
  console.log(err);
  if (axios.isAxiosError(err)) {
    const code = err.response?.data?.error?.code;
    if (code === 401) {
      ctx.navigate("auth-error");
    }
    const msg = err.response?.data?.error?.message;
    if (msg) {
      if (typeof msg === "string") {
        ctx.msgDialog.setState({ title: "エラー", message: msg });
      } else {
        let message = "";
        for (const k in msg) {
          message += `${k} : ${msg[k]}\n`;
        }
        console.log(message);
        ctx.msgDialog.setState({ title: "エラー", message });
      }
    } else {
      ctx.msgDialog.setState({ title: "エラー", message: err.message });
    }
  } else {
    const message = (err as any).message ?? "不明なエラー";
    ctx.msgDialog.setState({ title: "エラー", message });
  }
}

export function hasFile(target?: CommonFileModel) {
  if (!target) {
    return false;
  }
  if (target.file_data || target.image_data || target.image_url) {
    return true;
  }
  return false;
}

export function addDeleteFlag(target?: CommonFileModel) {
  if (!target) {
    return;
  }
  delete target.is_delete;
  if (hasFile(target)) {
    return;
  }
  if (target.seq_no !== undefined && target.seq_no !== null) {
    target.is_delete = true;
  }
}

export function addSuffixPhoneNumber(phoneNumber = '') {
  if (!phoneNumber) return '';

  const value = phoneNumber.replace(/\D/g, '').match(/(\d{0,3})(\d{0,4})(\d{0,4})/);

  if(!value) return '';
  return value[1] + (value[2] ? '-' + value[2] : '') + (value[3] ? '-' + value[3] : '')
}
